import React from 'react';
import styles from './CenteredPar.module.css';

interface CenteredParProps {
    text: string;
    textColor?: string;
}

const CenteredPar: React.FC<CenteredParProps> = ({
    text, 
    textColor = "#003600",
}) => {
    return (
        <>
            <p
                className={styles.parText}
                style={
                    {
                        '--text-color': textColor
                    } as React.CSSProperties
                }
            >
                {text}
            </p>
        </>
    );
};

export default CenteredPar;